import { apiRequest } from '../helpers'

export interface VertecConnectionStatus {
  configured: boolean
  server?: string
  updatedAt?: string
}

export interface VertecImportContact {
  vertecId: number
  name: string
}

export interface VertecImportCandidate {
  vertecId: number
  isPerson: boolean
  name: string
  firstName: string
  dateOfBirth: string
  streetAddress: string
  zipCode: string
  city: string
  country: string
  email: string
  phoneNumber: string
  customerNum: string
  contacts: VertecImportContact[]
}

export async function getVertecConnectionStatus(): Promise<VertecConnectionStatus> {
  return apiRequest(`${process.env.REACT_APP_API_URL}/vertec/connection/status`, 'GET')
}

export async function saveVertecConnection(payload: {
  server: string
  apiToken: string
}): Promise<{ ok?: boolean; message?: unknown }> {
  return apiRequest(`${process.env.REACT_APP_API_URL}/vertec/connection`, 'POST', payload)
}

export async function deleteVertecConnection(): Promise<{ ok?: boolean }> {
  return apiRequest(`${process.env.REACT_APP_API_URL}/vertec/connection`, 'DELETE')
}

export interface VertecObjectsResult {
  ok: boolean
  classname: string
  count: number
  data: unknown
}

export async function fetchVertecObjects(
  classname: string,
  params: Record<string, string> = {}
): Promise<VertecObjectsResult> {
  const query = new URLSearchParams(params).toString()
  const suffix = query ? `?${query}` : ''
  return apiRequest(
    `${process.env.REACT_APP_API_URL}/vertec/objects/${encodeURIComponent(classname)}${suffix}`,
    'GET'
  )
}

export async function fetchVertecImportCandidates(
  type: 'companies' | 'persons'
): Promise<{ ok: boolean; candidates: VertecImportCandidate[] }> {
  return apiRequest(`${process.env.REACT_APP_API_URL}/vertec/import/candidates?type=${type}`, 'GET')
}

export async function saveVertecImportCandidates(
  candidates: VertecImportCandidate[]
): Promise<{ ok: boolean; created: number; updated: number }> {
  return apiRequest(`${process.env.REACT_APP_API_URL}/vertec/import/candidates`, 'POST', {
    candidates,
  })
}
